// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import styled from "styled-components";

const mobileQuery = "@media (max-width: 767px)";

export default styled.div`
    ${mobileQuery} {
        flex-direction: column;
        row-gap: 1rem;
    }
    margin-top: 1.5rem;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${getColor("primary")};
    color: white;
    align-self: center;
    border-radius: 0.5rem;
    padding: 2rem;
`;
